import { Mapper, AppMapperError } from 'module/Common';
import { PageListItem } from './PageListItem';

export { PageListItem } from './PageListItem';
export type PageList = Array<PageListItem>;

export namespace PageList {
  export const mapper = Mapper.errorWrapper(
    err => new AppMapperError('PageList', err),
    Mapper.array(PageListItem.mapper)
  );
}



// WEBPACK FOOTER //
// ./src/module/Model/PageList/index.ts